module.exports = __webpack_public_path__ + "static/media/Male 1_1591272458165.0cb75e82.png";